export const LanguageFlagsUrls = new Map<string, string>([
  ['en', '/assets/images/flags/en-small.png'],
  ['fr', '/assets/images/flags/fr-small.png'],
  ['es', '/assets/images/flags/es-small.png'],
  ['nl', '/assets/images/flags/nl-small.png'],
  ['de', '/assets/images/flags/de-small.png'],
  ['it', '/assets/images/flags/it-small.png'],
]);
